import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Card from "../components/Card";
import { userRequest } from "../requestMethods";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Profile = () => {
  const location = useLocation();
  const userId = location.pathname.split("/")[2];
  const [myVideo, setMyVideo] = useState([]);
  useEffect(() => {
    const getMyVideo = async () => {
      const res = await userRequest.get(`/videos/getmyvideos/${userId}`);
      setMyVideo(res.data);
    };
    getMyVideo();
  }, [userId]);


  return (
    <Container>
      {myVideo &&
        myVideo.map((video) => <Card key={video?._id} video={video} />)}
    </Container>
  );
};

export default Profile;
